// apps/canifight/src/components/StatsPanel.jsx
import styles from './StatsPanel.module.css';

export default function StatsPanel({ userStats, statKeys, onClose, onRetake }) {
  const total = userStats.reduce((a, b) => a + b, 0);
  return (
    <div className={styles.overlay}>
      <button className={styles.closeBtn} onClick={onClose}>✕</button>
      <div className={styles.inner}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.avatar}>🧑</div>
            <div>
              <div className={styles.name}>YOU</div>
              <div className={styles.score}>Total: {total} / 120</div>
            </div>
          </div>
          {statKeys.map((key, i) => (
            <div key={key} className={styles.statRow}>
              <div className={styles.statName}>{key}</div>
              <div className={styles.statBar}>
                <div className={styles.statFill} style={{ width: `${userStats[i] * 10}%` }} />
              </div>
              <div className={styles.statVal}>{userStats[i]}</div>
            </div>
          ))}
        </div>
        <button className={styles.retakeBtn} onClick={onRetake}>
          Retake Survey
        </button>
      </div>
    </div>
  );
}
